// Module
var code = `<div class="js-messagebox-screen-main-panel">
    <div class="js-messagebox-screen">
        <div class="js-info {{infoCustomCss}}">
            <svg>
                <use xlink:href="assets/webdesktop/web-desktop-sprite.svg#{{iconSvg}}"></use>
            </svg>
            <terceraLabel name="mainTextLabel" text="{{.messageBoxText}}" additionalClass="js-default-message-text"/>
        </div>
        
        {{#if .errorMode}}
            <div class="js-info warning-message">
                <svg>
                    <use xlink:href="assets/webdesktop/web-desktop-sprite.svg#menuError"></use>
                </svg>
                <terceraLabel name="errorTextLabel" text="{{.errorText}}"/>
            </div>
        {{/if}}
    </div>

    <div class="js-buttons-bar">
        <div class="js-buttons-combination">
            <terceraButton terceraButtonStyle="{{.btnOKStyle}}" text="{{.okText}}" on-btnClick="okClick" tooltip="{{.okToolTop}}"/>
            {{#if !(.hideCancel)}}
                <terceraButton terceraButtonStyle="{{.btnCancelStyle}}" text="{{.cancelText}}" on-btnClick="cancelClick" tooltip="{{.cancelToolTop}}"/>
            {{/if}}
        </div>

        {{#if .showNextTimeChB}}
            <reactFormLabel label="{{.showNextTimeText}}">
                <reactCheckbox 
                    checked="{{.showNextTime}}" 
                    on-onChange="@this.onShowNextTimeChanged(\$1)" />
            </reactFormLabel>
        {{/if}}
    </div>
</div>

`;
// Exports
export default code;